import { useSyncExternalStore } from "react";

import {
  type ClinicReportScope,
  getClinicReportScope,
  subscribeToClinicReportScope,
} from "@/api/analytics/clinic-report-scope";

export function useClinicReportScope(): ClinicReportScope | null {
  return useSyncExternalStore(
    subscribeToClinicReportScope,
    getClinicReportScope,
    () => null,
  );
}
